import { render, staticRenderFns } from "./PlantSatgas.vue?vue&type=template&id=a72f53c6"
import script from "./PlantSatgas.vue?vue&type=script&lang=js"
export * from "./PlantSatgas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports